/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';

@Component({
  selector: 'xrx-incrementer',
  templateUrl: './xrx-incrementer.component.html',
  styleUrls: ['./xrx-incrementer.component.less'],
  standalone: false,
})
export class XrxIncrementerComponent implements OnInit {
  @Input() label: string;
  @Input() initialValue: number;
  @Input() maxLength: number;
  @Input() icon: any;
  @Input() isMfd = true;
  @Input() isPrint = false;
  @Output() valueChange = new EventEmitter<any>();

  value = 1;
  maxValue: number;

  ngOnInit(): void {
    this.maxValue = 10 ** this.maxLength - 1;
    if (this.initialValue) {
      this.value = this.initialValue;
    }
  }

  changeValue(inc: boolean) {
    if (this.value < this.maxValue && inc) {
      this.value++;
    } else if (this.value > 1 && !inc) {
      this.value--;
    }
    this.valueChange.emit(this);
  }
}
